import $ from 'jquery';

$(document).ready(function(){

  $(".slider .owl-carousel").owlCarousel({
    items: 1,
    slideBy: 1,
    margin: 32,
    autoHeight: true,
    nav: true,
    transition: 'fade',
    navText: [
      '<svg width="10px" height="17px" viewBox="0 0 10 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
      '    <g id="Design-Round-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
      '        <g id="Style-Guide" transform="translate(-115.000000, -8568.000000)" fill="currentColor">\n' +
      '            <g id="UI-Components" transform="translate(111.000000, 7292.000000)">\n' +
      '                <g id="Pager-dots" transform="translate(3.000000, 1209.000000)">\n' +
      '                    <g id="Group-2" transform="translate(1.000000, 67.000000)">\n' +
      '                        <path d="M-2.71175679,4.45806263 C-2.055332,3.80743921 -0.977242193,3.80743921 -0.320884762,4.45806263 L4.79829908,9.51514767 L9.91680939,4.44187382 C10.5732342,3.79125039 11.651324,3.79125039 12.3076814,4.44187382 C12.9641062,5.09249724 12.9641062,6.16105909 12.3076814,6.81161576 L5.99398767,13.0701778 C5.67432914,13.3870113 5.25337132,13.5539063 4.79819805,13.5539063 C4.34369831,13.5539063 3.92274049,13.3700547 3.60240843,13.0701778 L-2.71195834,6.82797146 C-3.03161687,6.49418149 -3.2,6.06063838 -3.2,5.64340091 C-3.19979845,5.20909008 -3.03141532,4.79185261 -2.71175679,4.45806263 Z" id="Fill-1-Copy-4" transform="translate(4.800000, 8.753906) rotate(-270.000000) translate(-4.800000, -8.753906) "></path>\n' +
      '                    </g>\n' +
      '                </g>\n' +
      '            </g>\n' +
      '        </g>\n' +
      '    </g>\n' +
      '</svg>',
      '<svg width="10px" height="17px" viewBox="0 0 10 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
      '    <g id="Design-Round-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
      '        <g id="Style-Guide" transform="translate(-254.000000, -8568.000000)" fill="currentColor">\n' +
      '            <g id="UI-Components" transform="translate(111.000000, 7292.000000)">\n' +
      '                <g id="Pager-dots" transform="translate(3.000000, 1209.000000)">\n' +
      '                    <g id="Group-2" transform="translate(1.000000, 67.000000)">\n' +
      '                        <path d="M136.288243,4.45806263 C136.944668,3.80743921 138.022758,3.80743921 138.679115,4.45806263 L143.798299,9.51514767 L148.916809,4.44187382 C149.573234,3.79125039 150.651324,3.79125039 151.307681,4.44187382 C151.964106,5.09249724 151.964106,6.16105909 151.307681,6.81161576 L144.993988,13.0701778 C144.674329,13.3870113 144.253371,13.5539062 143.798198,13.5539062 C143.343698,13.5539062 142.92274,13.3700547 142.602408,13.0701778 L136.288042,6.82797146 C135.968383,6.49418149 135.8,6.06063838 135.8,5.64340091 C135.800202,5.20909008 135.968585,4.79185261 136.288243,4.45806263 Z" id="Fill-1-Copy-5" transform="translate(143.800000, 8.753906) rotate(-90.000000) translate(-143.800000, -8.753906) "></path>\n' +
      '                    </g>\n' +
      '                </g>\n' +
      '            </g>\n' +
      '        </g>\n' +
      '    </g>\n' +
      '</svg>'
    ],
    onInitialized: function(event) {
      console.log('init');
      // move the nav around the dots
      var owl = $(event.target);
      owl.find('.owl-nav .owl-prev').after(
        owl.find('.owl-dots')
      );

        $(".slider .owl-carousel").trigger('refresh.owl.carousel')
    }
  });

});